<template>
    <div
        class="field-select field-wrap"
        v-bind:class="getClass"
        v-bind:selected-value="simpleFieldGet"
    >
        <v-select
            :disabled="checkDisabled"
            :value="getSelectedValue"
            @input="setSelectedValue"
            :options="getSelectOptions"
            :searchable="false"
            :clearable="this.hideClear === true ? false : true"
        ></v-select>

        <label class="field-select__label">
            {{ label
            }}<span v-if="label && required" class="field-select__label-required">&nbsp;*</span>
        </label>

        <!--
        <select :disabled="checkDisabled" v-model="simpleFieldModel">
            <option value="">Bitte auswählen</option>
            <option
                v-for="(value, key) in options"
                v-bind:key="key"
                v-bind:value="Array.isArray(options) ? value : key"
            >
                {{ value }}
            </option>
        </select>

        <pre>Selected: {{ simpleFieldGet }}</pre>
        -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SimpleFieldMixin } from '@/mixins/SimpleFieldMixin';
import vSelect from 'vue-select';

export default {
    data() {
        return {};
    },
    components: {
        'v-select': vSelect
    },
    mixins: [SimpleFieldMixin],
    methods: {
        setSelectedValue(val) {
            if (
                val !== undefined &&
                val !== null &&
                val !== '' &&
                typeof val === 'object' &&
                'value' in val &&
                val.value !== undefined &&
                val.value !== null &&
                val.value !== ''
            ) {
                this.simpleFieldSet(val.value);
            } else {
                this.simpleFieldSet('');
            }
        }
    },
    computed: {
        ...mapGetters(['getProp']),
        getClass() {
            let customClass = [];
            if (this.simpleFieldGet) {
                customClass.push('field-select--has-content');
            }
            if (this.customClass) {
                customClass.push('field-select--' + this.customClass);
            }
            if (this.required && !this.simpleFieldGet) {
                customClass.push('field-select--is-invalid');
            }
            return customClass;
        },
        getSelectOptions() {
            let options = this.options;
            if (options === undefined || options === null) {
                return [];
            }
            if (typeof options === 'string' || options instanceof String) {
                options = this.getProp(options);
            }
            if (Array.isArray(options)) {
                let ret = [];
                options.forEach((value) => {
                    ret.push({ label: value, value: value });
                });
                return ret;
            }
            if (typeof options === 'object') {
                let ret = [];
                Object.entries(options).forEach(([key, value]) => {
                    ret.push({ label: value, value: key });
                });
                return ret;
            }
            return [];
        },
        getSelectedValue() {
            if (this.simpleFieldGet) {
                let options = this.options;
                if (typeof options === 'string' || options instanceof String) {
                    options = this.getProp(options);
                }
                if (Array.isArray(options)) {
                    return { label: this.simpleFieldGet, value: this.simpleFieldGet };
                }
                if (typeof options === 'object') {
                    return { label: options[this.simpleFieldGet], value: this.simpleFieldGet };
                }
            }
            return undefined;
        }
    },
    props: {
        options: [String, Object, Array],
        customClass: String,
        hideClear: Boolean
    }
};
</script>
